import { render } from "./PlaMelStatusSelect.vue?vue&type=template&id=1797203e"
import script from "./PlaMelStatusSelect.vue?vue&type=script&lang=js"
export * from "./PlaMelStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__